module.exports = __webpack_public_path__ + "media/images/ibjjf/ranking-bg-8b0e2f66c78d14f7bb10543ff64f7a9d.jpg";